export const name = "TO_BASE32";
export const summary = `Converts a \`BYTES\` value to a base32-encoded \`STRING\` value.`;
export const reference = `
## TO_BASE32

Converts a \`BYTES\` value to a base32-encoded \`STRING\` value.

\`\`\`
TO_BASE32(bytes_expr)
\`\`\`

### Description

Converts a sequence of \`BYTES\` into a base32-encoded \`STRING\`. To convert a base32-encoded \`STRING\` into \`BYTES\`, use FROM_BASE32.


### Return type

\`STRING\`


### Example



\`\`\`
SELECT TO_BASE32(b'abcde\\xFF') AS base32_string;

/*------------------*
 | base32_string |
 +------------------+
 | MFRGGZDF74====== |
 *------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
